import { UserProfile, ITemplateDynamicInfo } from "../types";

const isValidUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;
  return url.startsWith('http://') || url.startsWith('https://');
};

export function buildClasses(profile, customizationObject) {
  const result = { classes: {} };

  // Fallback: if bookCover is not a valid URL, use bookCover3D
  if (customizationObject && !isValidUrl(customizationObject.bookCover) && isValidUrl(customizationObject.bookCover3D)) {
    customizationObject = { ...customizationObject, bookCover: customizationObject.bookCover3D };
  }

  const entries = {
    photo: {
      path: ['headshot', 'imageUrl'],
      source: [customizationObject, profile],
      nested: 'masked_media',
    },
    logo: {
      path: ['brokerLogo'],
      source: customizationObject,
      nested: 'media',
    },
    bookCover2D: {
      path: ['bookCover'],
      source: customizationObject,
      nested: 'masked_media',
    },
    bookCover3D: {
      path: ['bookCover3D'],
      source: customizationObject,
      nested: 'masked_media',
    },
    leadCaptureSite: {
      path: ['website'],
      source: customizationObject,
      nested: 'text',
    },
    socialsCTA: {
      path: ['ctaText'],
      source: customizationObject,
      nested: 'text',
    },
    name: {
      path: ['fullName', 'firstname'],
      source: [customizationObject, profile],
      nested: 'text',
    },
    email: {
      path: ['email'],
      source: [customizationObject, profile],
      nested: 'text',
    },
    phone1: {
      path: ['phone'],
      source: [customizationObject, profile],
      nested: 'text',
    },
  };

  for (const key in entries) {
    const { path, source, nested } = entries[key];
    const sources = Array.isArray(source) ? source : [source];

    for (const s of sources) {
      if (!s) continue;
      for (const p of path) {
        if (s.hasOwnProperty(p) && s[p] != null && s[p] !== '') {
          if (nested === 'masked_media') {
            result.classes[key] = { masked_media: { url: s[p] } };
          } else if (nested === 'media') {
            result.classes[key] = { url: s[p] };
          } else if (nested === 'text') {
            result.classes[key] = { text: s[p], auto_fit: true };
          }
          break;
        }
      }
      if (result.classes[key]) break;
    }
  }

  return result;
}

export function createTemplateCustomizationObject(profile: UserProfile, templateDynamicInfo: ITemplateDynamicInfo) {
  return buildClasses(profile, templateDynamicInfo);
}

export const categoriesMapper = {
  'social-media-templates': { id: 4, name: 'Social Media Templates', key: 'social-media-templates' },
  'instant-trust-package': { id: 7, name: 'Instant Trust Package', key: 'instant-trust-package' },
  'biz-card-series': { id: 8, name: 'Biz Card Series', key: 'biz-card-series' },
  'home-buyers-guide-series': { id: 9, name: "Home Buyer's Guide Series", key: 'home-buyers-guide-series' },
  'welcome-bundle': { id: 10, name: 'Welcome Bundle', key: 'welcome-bundle' },
  'ads': { id: 12, name: 'Ads', key: 'ads' },
  'email-banner': { id: 13, name: 'Email Banner', key: 'email-banner' },
  'seller-guide': { id: 14, name: 'Seller Guide', key: 'seller-guide' },
  'buyer-guide': { id: 15, name: 'Buyer Guide', key: 'buyer-guide' },
};

export const categoriesList = [
  { id: 4, name: 'Social Media Templates', key: 'social-media-templates' },
  { id: 7, name: 'Instant Trust Package', key: 'instant-trust-package' },
  { id: 8, name: 'Biz Card Series', key: 'biz-card-series' },
  { id: 9, name: "Home Buyer's Guide Series", key: 'home-buyers-guide-series' },
  { id: 10, name: 'Welcome Bundle', key: 'welcome-bundle' },
  { id: 12, name: 'Ads', key: 'ads' },
  { id: 13, name: 'Email Banner', key: 'email-banner' },
  { id: 14, name: 'Seller Guide', key: 'seller-guide' },
  { id: 15, name: 'Buyer Guide', key: 'buyer-guide' },
];

export function getCategoryFromUrl() {
  const pathSegments = window.location.pathname.split('/');
  const categoryFromUrl = pathSegments[pathSegments.length - 1];

  return categoriesMapper[categoryFromUrl];
}
